import { useOutletContext } from 'react-router-dom'
import { type Reps } from 'service/api'

export function useRepsOutletContext() {
    return useOutletContext<{
        data?: Reps[]
    }>()
}
